import { render, staticRenderFns } from "./StoreItemCardView.vue?vue&type=template&id=13aaeaaf&scoped=true&"
import script from "./StoreItemCardView.vue?vue&type=script&lang=ts&"
export * from "./StoreItemCardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aaeaaf",
  null
  
)

export default component.exports